<template>
  <div class="container">
      <div class="title text-medium">Трохи про Нова пошта Гранд Пікнік</div>
      <div class="row d-flex">
        <div class="col d-flex">
          <div class="about__item d-flex w100 flex-column">
            <img src="./../assets/images/about/item1.png" class="about__item-icon" alt="">
            <div class="about__item-text">Подія, якої ще ніколи не було в Новій пошті</div>
          </div>
        </div>
        <div class="col">
          <div class="about__item">
            <img src="./../assets/images/about/item2.png" class="about__item-icon" alt="">
            <div class="about__item-text">Наймасштабніший оффлайн-квест в Україні</div>
          </div>
        </div>
        <div class="col">
          <div class="about__item">
            <img src="./../assets/images/about/item3.png" class="about__item-icon" alt="">
            <div class="about__item-text">Активності та розваги на свіжому повітрі</div>
          </div>
        </div>
        <div class="col">
          <div class="about__item">
            <img src="./../assets/images/about/item4.png" class="about__item-icon" alt="">
            <div class="about__item-text">Концерт Олі Полякової та світлове лазер-шоу</div>
          </div>
        </div>
        <div class="col">
          <div class="about__item">
            <img src="./../assets/images/about/item5.png" class="about__item-icon" alt="">
            <div class="about__item-text">Незабутній час з колегами та нові знайомства</div>
          </div>
        </div>
        <div class="col">
          <div class="about__item">
            <img src="./../assets/images/about/item6.png" class="about__item-icon" alt="">
            <div class="about__item-text">Де: м. Київ, музей Пирогово
              Коли: 13 серпня 2021 року</div>
          </div>
        </div>
      </div>
      <div class="about-sticker position-relative d-flex align-center justify-center text-center">
        Правда, круто! <span class="about-sticker__icon position-absolute d-block">👍</span>
      </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped lang="scss">
@use 'sass:math';
@import '../assets/styles/parts/variables';
@import '../assets/styles/parts/mixins';
.title {
  font-size: sm(24);
  padding-bottom: sm(38);
  padding-top: sm(72);
  @include _1024 {
    padding-top: sl(120);
    padding-bottom: sl(80);
    font-size: sl(48);
  }
  @include _1920 {
    padding-top: 120px;
    padding-bottom: 80px;
    font-size: 48px;
  }
}
.about-sticker {
  font-size: sm(16);
  width: sm(158);
  height: sm(48);
  box-shadow: 0px 6px 12px rgba(84, 101, 101, 0.12);
  border-radius: sm(8);
  transform: rotate(-10deg);
  background: $white;
  margin-top: sm(30);
  margin-bottom: sm(23);
  margin-left: auto;
  margin-right: auto;

  @include _1024 {
    font-size: sl(24);
    width: sl(221);
    height: sl(60);
    border-radius: sl(8);
    margin-left: sl(72);
    margin-top: sl(74);
    margin-bottom: sl(60);
  }
  @include _1920 {
    font-size: 24px;
    width: 221px;
    height: 60px;
    border-radius: 8px;
    margin-left: 72px;
    margin-top: 74px;
    margin-bottom: 60px;
  }
  &__icon {
    width: sm(32);
    height: sm(48);
    transform: rotate(10deg);
    text-shadow: 3px 4px 10px rgba(84, 101, 102, 0.25);
    left: sm(-17);
    top: sm(-25);
    font-size: sm(32);
    @include _1024 {
      width: sl(48);
      height: sl(72);
      left: sl(-23);
      top: sl(-40);
      font-size: sl(48);
    }
    @include _1920 {
      width: 48px;
      height: 72px;
      left: -23px;
      top: -40px;
      font-size: 48px;
    }
  }
}
.row {
  flex-wrap: wrap;
  @include row;
}
.col {
  width: 100%;
  @include col;
  padding-bottom: sm(8);
  padding-top: sm(8);
  @include _1024 {
    width: math.div(100%, 3);
    padding-top: sl(8);
    padding-bottom: sl(8);
  }
  @include _1920 {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
.about {
  &__item {
    background-color: $white;
    min-height: sm(184);
    border: 1px solid $border-gray;
    border-radius: sm(12);
    @include _1024 {
      min-height: sl(264);
      border-radius: sl(12);
    }
    @include _1920 {
      min-height: 264px;
      border-radius: 12px;
    }
    &-icon {
      width: sm(70);
      height: sm(70);
      margin: sm(19);
      object-fit: contain;
      object-position: center;
      @include _1024 {
        width: sl(100);
        height: sl(100);
        margin: sl(34);
      }
      @include _1920 {
        width: 100px;
        height: 100px;
        margin: 34px;
      }
    }
    &-text {
      font-size: sm(16);
      padding: sm(4) sm(24) sm(24);
      @include _1024 {
        font-size: sl(24);
        padding: 0 sl(24) sl(32);
      }
      @include _1920 {
        font-size: 24px;
        padding: 0 24px 32px;
      }
    }
  }
}
</style>
